import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';


class CountBackModal extends Component {

	constructor(props) {
		super(props)
		this.state = {};

		this.toggleModal = this.toggleModal.bind(this);
		this.countback   = this.countback.bind(this);
		this.timer  	 = this.timer.bind(this);
		this.handleCancel =this.handleCancel.bind(this);
		this.handleLogout =this.handleLogout.bind(this);
	}

	 componentDidMount() {
		let self=this;
		self.setState({
			modal: this.props.modal,
			countingBack :true,
			countBackFrom: this.props.countBackFrom}
		,()=>self.countback());

	}

	handleCancel(){
		this.setState({countingBack:false, countBackFrom:this.props.countBackFrom},()=>this.props.handleCancel());

	}

	handleLogout(){
		this.setState({countingBack:false, countBackFrom:this.props.countBackFrom},()=>this.props.handleLogout());

	}

	toggleModal() {
		this.props.toggle();
	}


	async countback(){
		let self=this;
		while(self.state.countBackFrom>0 && self.state.countingBack){
			await self.timer(1000);
			self.setState({countBackFrom:self.state.countBackFrom-1});
		}
		if(self.state.countBackFrom===0)
		{
			self.setState({countBackModalVisible:false,countBackFrom:10,countingBack:false},()=>this.handleLogout());
		}
	}

	timer(ms) {
		return new Promise(res => setTimeout(res, ms));
	}


	render() {
		return (
			<Modal isOpen={this.state.modal} keyboard={true} size="md">
				<ModalHeader>Oturumunuz Sonlandırılacaktır...</ModalHeader>
				<ModalBody>
					<div className="row" style={{ position: 'relative' }}>
						<p><h4>{this.props.maxIdleTimeout} dakika süresince işlem yapmadınız.
							Oturumunuz {this.state.countBackFrom} saniye sonra otomatik olarak
							sonlandırılacaktır!</h4></p>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className="col-sm-12 row">
						<div className="col-sm-3">
							<button type="button" onClick={this.handleCancel}
									className=" TekBtn delete" style={{
								padding: '9PX 43PX 9PX 15PX',
								background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))'
							}}>Sürdür
							</button>
						</div>
						<div className="col-sm-6"></div>
						<div className="col-sm-3">
							<button type="button" onClick={this.handleLogout} className="  TekBtn kaydet "
									style={{padding: '9PX 43PX 9PX 15PX'}}>Sonlandır
							</button>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		)
	}
}


export default CountBackModal;



